<!-- InputField.vue -->
<template>
  <DbInput
    v-model="formattedInputValue"
    :value="formattedInputValue"
    @input="handleInput"
    :ariainvalid="ariainvalid"
    class="w-full hydrated"
    :placeholder="placeholder"
    :disabled="disabled"
  ></DbInput>
</template>

<script setup lang="ts">
import { ref, computed, defineProps, defineEmits } from "vue";
import DbInput from "../DB-Components/DbInput.vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  ariainvalid: {
    type: String as () => "false" | "grammar" | "spelling" | "true" | undefined,
    default: "false",
    required: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: null,
  },
});
const inputValue = ref(props.modelValue);
const emit = defineEmits(["update:modelValue"]);

const formattedInputValue = computed(() => {
  let formattedString = inputValue.value == null ? "" : inputValue.value;
  if (formattedString) {
    const leadingIgnoredCharactersStripped = formattedString.replace(
      /^[,/\\\s-]+/,
      ""
    );
    const endingIgnoredCharactersStripped =
      leadingIgnoredCharactersStripped.replace(/^[,/\\\s-]+/, "");
    formattedString = endingIgnoredCharactersStripped;
  }
  return formattedString;
});

const handleInput = (event: HTMLInputElement) => {
  const target = event.target as HTMLInputElement;
  const licenseNumber = target.value.toUpperCase();
  emit("update:modelValue", licenseNumber);
};
</script>
